import { DepositDayType } from '@urbanx/agx.campaigns.client';
import { DropdownOption } from '@urbanx/agx.ui-components2';


export const BusinessDaysOptions: DropdownOption[] = [
  { label: 'day(s)', value: DepositDayType.Days },
  { label: 'business day(s)', value: DepositDayType.BusinessDays },
];
